import { render, staticRenderFns } from "./tab-text.html?vue&type=template&id=6476e479&scoped=true&"
import script from "./tab-text.js?vue&type=script&lang=js&"
export * from "./tab-text.js?vue&type=script&lang=js&"
import style0 from "./tab-text.scss?vue&type=style&index=0&id=6476e479&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6476e479",
  null
  
)

export default component.exports